import type { SVGProps } from 'react';

export function UserAddIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M9.9987 9.99935C12.2999 9.99935 14.1654 8.13387 14.1654 5.83268C14.1654 3.5315 12.2999 1.66602 9.9987 1.66602C7.69751 1.66602 5.83203 3.5315 5.83203 5.83268C5.83203 8.13387 7.69751 9.99935 9.9987 9.99935Z'
        stroke='currentColor'
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M2.83984 18.3333C2.83984 15.1083 6.04817 12.5 9.99817 12.5C10.7982 12.5 11.5732 12.6083 12.2982 12.8083'
        stroke='currentColor'
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M18.3346 14.9993C18.3346 15.266 18.3013 15.5243 18.2346 15.7743C18.1596 16.1077 18.0263 16.4327 17.8513 16.716C17.2763 17.6827 16.218 18.3327 15.0013 18.3327C14.143 18.3327 13.368 18.0077 12.7846 17.4743C12.5346 17.2577 12.318 16.9993 12.1513 16.716C11.843 16.216 11.668 15.6243 11.668 14.9993C11.668 14.0993 12.0263 13.2744 12.6096 12.6744C13.218 12.0494 14.068 11.666 15.0013 11.666C15.9846 11.666 16.8763 12.091 17.4763 12.7744C18.0096 13.366 18.3346 14.1493 18.3346 14.9993Z'
        stroke='currentColor'
        strokeWidth='1.2'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M16.2411 14.9844H13.7578'
        stroke='currentColor'
        strokeWidth='1.2'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M15 13.7676V16.2592'
        stroke='currentColor'
        strokeWidth='1.2'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
